/**
 * APP 推荐位Key值枚举
 */
export enum CROSS_SELL_APP_KEY {
  PARCEL_PANEL = "5crtj8wVLilMPO2W4m25bq13EeoSlL6g",
  RETURN = "HILSZlKlWgM4zhk1GYjawvijNn0Eab9z",
}

/**
 * 推荐位枚举
 */
// lib/cross-sell-tracking/cross-sell-point.ts
export enum CROSS_SELL_POINT_ENUM {
  /**
   * PP to Return
   */
  // Tracking page Return推荐位
  PostPurchaseHubReturn = "92ff8466-41eb-46c2-bf4f-97065bbea25b",

  // 集成页面Return推荐位
  IntegrationReturn = "10ee25eb-e69e-4bdd-aeba-fbf6a2aba1f3",

  // Special offer推荐位
  SpecialOfferReturn = "9b5baed1-f8ec-4f4b-a117-95fc3f68eea1",

  // Recommended推荐位
  RecommendedReturn = "8c27dfa2-ecbe-42d2-9aea-a3ce57545f82",

  // Orders Banner return推荐位
  OrdersReturn = "0da9d2be-c696-4d9d-ab6b-6cd2a7f1e3ae",

  // Setting return推荐位
  SettingsReturn = "76ac53fa-6b51-44d6-9b70-591876a1c9a8",

  /**
   * PP to Protection
   */

  // Tracking page Protection推荐位
  PostPurchaseHubProtection = "de8e8fc1-5705-4b7c-bb88-b94d20b929bf",

  // 订单详情页Protection推荐位
  OrdersDetailProtection = "32164903-a34e-4799-8ab4-79908116b08d",

  // Dashboard—Exception Card
  DashboardExceptionCard = "01e3d8e2-185b-4278-90dc-74d579da7727",

  // Orders Banner Protection推荐位
  OrdersProtection = "0d1e4534-19d2-4f94-a1cc-0354f82fdd19",

  // Settings-Sender notifications
  SettingsSenderProtection = "3a236944-0bae-4b19-b90c-51b08ec146c4",

  // Settings-Recipient  notifications
  SettingsRecipientProtection = "b3ca3122-bd29-4d0a-a0bb-121799c495fe",

  // Special offer Protection推荐位
  SpecialOfferProtection = "ba29ccad-bd1d-455c-a6cd-0e860a9be497",

  // Recommended Protection推荐位
  RecommendedProtection = "2361113f-c5ac-47aa-a3b9-8c67c97846db",

  /**
   * Contact Cross Sell 推荐位
   */
  // SpecialOffer Contact 推荐位
  SpecialOfferContact = "f41f4005-6ac7-49d0-8b00-f26e55b19725",

  // Banner Contact 推荐位
  BannerContact = "008f97f6-61cd-4321-b7c4-5c9ccde62067",

  HelpCenterContact = "414c9e65-faba-4caa-b4f7-7345d112205b",

  // PPI helpcenter推荐位
  PPIHelpCenterContact = "db72b8d4-43ae-401c-ad3c-e3ba4a0a0dee",

  // Analytics-Exceptions Retain revenue
  AnalyticsExceptionsRetainRevenue = "bb967939-928c-4791-af33-bfbdc8c05ef6",

  // Orders - Sync orders button
  OrdersSyncOrdersButton = "3699bf27-45a8-4872-9011-e9965cdbfa7d",

  // Waive fee banners
  DashboardWaiveFeeBanner = "6c0b8974-8490-44b7-91c1-d7d0263f43cd",
  BillingWaiveFeeBanner = "bc48bc7b-22d7-4c70-8776-c47f5fc353a6",
  PricingPlanWaiveFeeBanner = "6fa44b2d-e026-4c2d-84b6-b5d49a117fe9",
}
